import React from "react";
import { HeadingBlockProps } from "./HeadingBlock.types";
import { HeadingBlockContent } from "@/modules/hub/features/ResourceLibrary/components/ResourceDetailsContentBlock/ResourceDetailsContentBlock";

export function HeadingBlock({ content }: HeadingBlockProps) {
  let headingData: HeadingBlockContent | null = null;

  try {
    headingData = JSON.parse(content) as HeadingBlockContent;
  } catch (e) {
    console.error("Failed to parse heading content:", e);
    return (
      <div className="my-6 p-4 border border-destructive/50 rounded-lg">
        <p className="text-destructive">
          Error: Invalid heading content format
        </p>
      </div>
    );
  }

  if (!headingData.text) {
    return null;
  }

  // Create anchor ID from text for deep linking
  const anchorId = headingData.text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

  // Dynamically create the heading element based on level
  const HeadingTag = headingData.level || "h2";

  const headingClasses = {
    h2: "text-2xl font-bold mt-8 mb-4 text-gray-900 dark:text-slate-100",
    h3: "text-xl font-bold mt-6 mb-3 text-gray-900 dark:text-slate-100",
    h4: "text-lg font-semibold mt-4 mb-2 text-gray-900 dark:text-slate-100",
    h5: "text-base font-semibold mt-3 mb-2 text-gray-900 dark:text-slate-100",
    h6: "text-sm font-semibold mt-2 mb-1 text-gray-900 dark:text-slate-100",
  };

  return (
    <HeadingTag
      className={headingClasses[headingData.level] || headingClasses.h2}
      id={anchorId}
    >
      {headingData.text}
    </HeadingTag>
  );
}
